<template>
	<router-link
		:tag="disabled ? 'template' : 'a'"
		:event="disabled ? '' : 'click'"
		:style="disabled ? 'cursor: default' : 'cursor: pointer'"
		:to="disabled ? '' : to"
		:class="[colors, routerLinkClasses]"
	>
		<slot></slot>
	</router-link>
</template>

<script>
export default {
	name: 'b-router-link',
	props: {
		/**
		 * Recebe a url de redirecionamento
		 */
		to: {
			type: String,
			required: true
		},
		/**
		 * Seta a cor do link, pode ser qualquer cor disponível no DLS
		 */
		color: {
			type: String,
			default: 'ink-base'
		},
		/**
		 * Seta a cor do link no hover, pode ser qualquer cor disponível no DLS
		 */
		hoverColor: {
			type: String,
			default: 'ink-base'
		},
		/**
		 * Desabilita o click no link
		 */
		disabled: Boolean,
		/**
		 * Classes para estilizar o link
		 */
		routerLinkClasses: {
			type: [String, Array],
			default:
				'router-link display-flex align-items-center no-decoration'
		}
	},
	computed: {
		colors() {
			return `${this.color} hover-${this.hoverColor}`;
		}
	}
};
</script>

<style lang="scss" scoped>
.router-link {
	height: inherit;
}
</style>

<docs>
    Link padrão do DLS

    As importações dos arquivos abaixo são necessárias para o funcionamento do componente:
    - styling.scss
    - position.scss

    ```js
    <b-router-link to="/">Default</b-router-link>
    <b-router-link to="/" disabled>Disabled</b-router-link>
    ```
</docs>
